import { current } from 'immer';
import { shouldUpdateState } from './helpers';

export const taskReducers = {
    leadNote(state, action) {
        state.leadNotes = action.payload;
    },
    leadNoteWithFilter(state, action) {
        state.leadNotesWithFilter = action.payload;
    },
    addLeadNotes(state, action) {
        state.leadNotes = [
            ...state.leadNotes,
            action.payload
        ];
    },
    AddLeadNotes(state, action) {
        state.leadNotesArr = action.payload;
    },
    getAllReminderData(state, action) {
        const currentState = current(state);

        if (shouldUpdateState(currentState.allReminders, action.payload)) {
            state.allReminders = action.payload;
        }
    },
    appendDashboardScheduledData(state, action) {
        if (state.allReminders) {
            const existingIds = new Set((state.allReminders.results || []).map(r => r.id));
            const newResults = (action.payload || []).filter(r => !existingIds.has(r.id));
            state.allReminders = {
                ...state.allReminders,
                count: (state.allReminders.count || 0) + newResults.length,
                results: [...(state.allReminders.results || []), ...newResults],
            };
        }
    },
    clearAllReminderData(state) {
        state.allReminders = null;
    },
    leadReminderData(state, action) {
        state.leadReminder = action.payload;
    },
    leadFlowReminderData(state, action) {
        state.leadFlowReminder = action.payload;
    },
    leadFlowReminderMoreData(state, action) {
        state.leadFlowReminder.results = [
            ...state.leadFlowReminder.results,
            ...action.payload.results
        ];
        state.leadFlowReminder.count = action.payload.count;
    },
    clearReminder(state) {
        state.leadReminder = null;
    },
    getTasksPageData(state, action) {
        state.taskPageData = action.payload;
        state.taskLaneCounts = null;
    },
    appendTasksPageData(state, action) {
        if (state.taskPageData && action.payload?.results) {
            state.taskPageData = {
                ...action.payload,
                results: [...(state.taskPageData.results || []), ...action.payload.results],
            };
        } else {
            state.taskPageData = action.payload;
        }
    },
    setTaskPageLaneData(state, action) {
        state.taskPageData = action.payload.merged;
        state.taskLaneCounts = action.payload.laneCounts;
    },
    setTaskLaneCounts(state, action) {
        state.taskLaneCounts = action.payload;
    },
    appendTasksLaneData(state, action) {
        const { results, lane, limit, offset } = action.payload;
        if (state.taskPageData) {
            if (results?.length) {
                state.taskPageData = {
                    ...state.taskPageData,
                    results: [...(state.taskPageData.results || []), ...results],
                };
            }
            // If returned fewer than requested, update lane count to actual loaded count
            if (lane && state.taskLaneCounts && results?.length < limit) {
                state.taskLaneCounts = {
                    ...state.taskLaneCounts,
                    [lane]: offset + results.length,
                };
            }
        }
    },
    addTaskTableData(state, action) {
        state.taskTableData = action.payload;
    },
    addTaskCounter(state, action) {
        state.leadTaskCounter = action.payload;
    },
    addLeadTaskTab(state, action) {
        state.leadTaskTab = action.payload;
    },
    updateTaskCounter(state, action) {
        state.taskCounter = action.payload;
    },
    cleanTaskCounter(state) {
        state.taskCounter = [];
    },
    updateLeadTaskCounter(state, action) {
        state.taskLeadCounter = action.payload;
    },
    updateFlowTaskCounter(state, action) {
        state.taskFlowCounter = action.payload;
    },
    updateSeparateTaskCounter(state, action) {
        state.separateTaskCounter = action.payload;
    },
    clearSeparateTaskCounter(state) {
        state.separateTaskCounter = [];
    },
    updateTableTags(state, action) {
        state.tableTag = action.payload;
    },
    setAssigned(state, action) {
        state.isAssigned = action.payload;
    },
    upComingTask(state, action) {
        state.upComingData = action.payload;
    },
    setDashboardTaskPageFilter(state, action) {
        state.dashboardTaskPageFilter = action.payload;
    },
    setLeadDetailTaskPageFilter(state, action) {
        state.leadDetailTaskPageFilter = action.payload;
    },
    setTaskPageFilter(state, action) {
        state.taskPageFilter = action.payload;
    },
    getTaskDetails(state, action) {
        state.taskDetail = action.payload;
    },
    taskCompletedUser(state, action) {
        state.isTasksCompleted = action.payload;
    },
    setTodoListFilter(state, action) {
        state.todoListFilter = action.payload;
    },
    taskUnassignedUser(state, action) {
        state.unassignedUser = action.payload;
    },
};
